<div class="d-flex flex-column gap-4">
    <div class="insurance-detail" *ngIf="insurance">
        <button class="btn link-btn btn-back-txt mb-5" (click)="returnHandler()">
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>{{'insurance.insuranceDetails.return' | translate}}</span>
        </button>
        <div class="row animated-row">
            <div class="col-12  text-center text-md-start">
                <dynamic-field [props]="insuranceProps.InsuranceType" [canBeEmpty]="true">
                    <div HJSuppress class="detail-insurer-type">
                        {{insurance.insuranceType}}
                    </div>
                </dynamic-field>
            </div>
        </div>
        <div class="row animated-row mb-3">
            <div class="col-md-6 text-center text-md-start">
                <dynamic-field [props]="insuranceProps.InsuranceNumber" [canBeEmpty]="true">
                    <div>
                        {{'insurance.insuranceDetails.policy' | translate}}:
                        <span HJSuppress class="fw-semibold">
                            {{insurance.insuranceNumber}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-md-6 text-center text-md-end">
                <dynamic-field [props]="insuranceProps.InsurerName" [canBeEmpty]="true">
                    <span HJSuppress class="fs-4">
                        {{insurance.insurerName}}
                    </span>
                </dynamic-field>
            </div>
        </div>
        <div class="row animated-row mb-3">
            <div class="col-md-6 text-center text-md-start">
                <dynamic-field [props]="insuranceProps.Valability" [canBeEmpty]="true">
                    <div>
                        {{'insurance.insuranceDetails.valability' | translate}}:
                        <span HJSuppress class="fw-semibold">
                            {{insurance.valability | localizedDate}}
                        </span>
                    </div>
                </dynamic-field>
                <dynamic-field *ngIf="insurance.contractNumber" [props]="insuranceProps.ContractNumber" [canBeEmpty]="true">
                    <div>
                        {{'insurance.insuranceDetails.contractNo' | translate}}
                        <span HJSuppress class="text-primary fw-bold">
                            {{insurance.contractNumber}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
            <div class="col-md-6 text-center text-md-end">
                <dynamic-field [props]="insuranceProps.Premium" [canBeEmpty]="true">
                    <div>
                        {{'insurance.insuranceDetails.premium' | translate}}:
                        <span HJSuppress class="fw-semibold">
                            {{ insurance?.premium | number:'1.2-2' }} {{ insurance?.currency }}
                        </span>
                    </div>
                </dynamic-field>
                <dynamic-field [props]="insuranceProps.PremiumCount" [canBeEmpty]="true">
                    <div>
                        {{'insurance.insuranceDetails.premiumCount' | translate}}:
                        <span HJSuppress class="fw-semibold">
                            {{insurance?.premiumCount}}
                        </span>
                    </div>
                </dynamic-field>
            </div>
        </div>
        <div class="row animated-row mb-1">
            <div class="col-12 text-center text-md-start text-secondary fw-semibold asset-label">
                {{'insurance.insuranceDetails.assets' | translate}}
            </div>
        </div>
        <div class="row animated-row mb-3">
            <dynamic-field class="col-12" [props]="insuranceProps.Asset" [canBeEmpty]="true">
                <div class="d-flex flex-column flex-md-row justify-content-between text-center px-2 py-3 asset-details-container">
                    <div HJSuppress>
                        {{insurance.asset?.name}}
                    </div>
                    <div HJSuppress class="fw-bold fs-6">
                        {{insurance.asset?.number}}
                    </div>
                    <div>
                        {{'insurance.insuranceDetails.vin' | translate}}:
                        <span HJSuppress class="fw-bold">
                            {{insurance.asset?.vin}}
                        </span>
                    </div>
                </div>
            </dynamic-field>
        </div>
        <div class="row animated-row">
            <dynamic-field class="col-12" [props]="insuranceProps.IssuedOn" [canBeEmpty]="true">
                <div class="asset-label text-end">
                    {{'insurance.insuranceDetails.issuedOn' | translate}}:
                    <span HJSuppress class="fw-bold">
                        {{insurance.issuedOn | localizedDate}}
                    </span>
                </div>
            </dynamic-field>
        </div>
    </div>
    <div class="card insurance-detail-card">
        <div class="card-body">
            <dynamic-table [props]="insuranceSchedulesProps" class="insurance-schedule-table">
                <table>
                    <thead>
                        <tr>
                            <th scope="col" id="MonthNo" width="10%">
                                <div>{{ "insurance.insuranceDetails.rateNumber" | translate }}</div>
                            </th>
                            <th scope="col" id="Amount" >
                                {{ "insurance.insuranceDetails.value" | translate }}
                            </th>
                            <th scope="col" id="DueDate">
                                {{ "insurance.insuranceDetails.invoiceDueDate" | translate }}
                            </th>
                            <th scope="col" id="InvoiceNumber">
                                {{ "insurance.insuranceDetails.invoiceNumber" | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let insuranceSchedule of insurancePaymentSchedules">
                            <td HJSuppress
                                [attr.data-label]="'insurance.insuranceDetails.rateNumber' | translate"
                                id="MonthNo"
                                class="text-secondary">
                                    {{ insuranceSchedule.monthNo }}
                            </td>
                            <td HJSuppress
                                [attr.data-label]="'insurance.insuranceDetails.value' | translate"
                                id="Amount">
                                <div class="d-flex align-items-center justify-content-center fw-bold">
                                    {{ insuranceSchedule.amount | number: "1.2" }} {{ insuranceSchedule.currency }}
                                </div>
                            </td>
                            <td HJSuppress
                                [attr.data-label]="'insurance.insuranceDetails.invoiceDueDate' | translate"
                                id="DueDate"
                                class="fw-semibold">
                                    {{ insuranceSchedule.dueDate | localizedDate }}
                            </td>
                            <td HJSuppress
                                [attr.data-label]="'insurance.insuranceDetails.invoiceNumber' | translate"
                                id="InvoiceNumber">
                                <button *ngIf="insuranceSchedule.invoiceNumber"
                                    class="btn column-link-btn invoice-number"
                                    (click)="invoiceHandler(insuranceSchedule.invoiceId)">
                                        {{ insuranceSchedule.invoiceNumber }}
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </dynamic-table>
        </div>
    </div>
</div>
